import { make } from 'vuex-pathify'
import api from '@/plugins/api'

const state = {
    historyHash: null,
    explanation: null,
    loading: true,
    currentPage: 1,
    fieldFilter: 'all',
    answerTypeFilter: 'all',
}

const actions = {
    getData({ state, commit }) {
        commit('SET_LOADING', true)

        api.get(
            `history/${state.historyHash}/explanation`,
            {
                params: {
                    page: state.currentPage,
                    field: state.fieldFilter,
                    answerType: state.answerTypeFilter
                }
            }
        )
            .then(response => {
                commit('SET_EXPLANATION', response.data)
                commit('SET_LOADING', false)
            })
    },

    reset({ commit }) {
        commit('SET_HISTORY_HASH', null)
        commit('SET_EXPLANATION', null)
        commit('SET_LOADING', true)
        commit('SET_CURRENT_PAGE', 1)
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations: make.mutations(state)
}
